var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRemoveCircle = function SvgRemoveCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B91C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.832 9.299-5.664 5.663M9.168 9.299l5.664 5.663M12 22.143c5.53 0 10.013-4.482 10.013-10.012S17.53 2.118 12.001 2.118 1.988 6.601 1.988 12.131s4.483 10.012 10.013 10.012"
  })));
};
export default SvgRemoveCircle;